// Aktionsmodul: Handwerker direkt beauftragen. Baut die Auftrags-Mail über die
// bereits vorhandene baueAuftragsMail() (lib/tickets/auftragsMail.ts) — exakt der
// heutige Text/Betreff, den der manuelle "Auftrag vorbereiten"-Flow verwendet.
import { supabase } from '../../supabase/client';
import { baueAuftragsMail } from '../../tickets/auftragsMail';
import type { AktionEntwurf, AktionKontext, AktionModul, TicketAktion } from '../types';

export function erzeugen(ctx: AktionKontext): AktionEntwurf | null {
  const stammdaten = ctx.stammdaten;
  if (!stammdaten || !stammdaten.dienstleister) return null;
  const { dienstleister, auftrag, anhaenge } = stammdaten;

  if (dienstleister.beauftragung_modus === 'angebot') return null;
  if (!dienstleister.email) return null;
  if (!auftrag) return null;

  const mail = baueAuftragsMail(auftrag);

  return {
    typ: 'handwerker_beauftragen',
    freigabe_erforderlich: true,
    ist_rechtlich_sensibel: false,
    empfaenger: mail.empfaenger,
    empfaenger_kontakt_id: dienstleister.id,
    betreff: mail.betreff,
    entwurf_text: mail.text,
    payload: { dienstleister_id: dienstleister.id, anhaenge },
    ki_confidence: ctx.ticket.ki_confidence ?? null,
  };
}

// Nachbereitung nach Mail-Versand (dünner Supabase-Wrapper, Konvention: nicht unit-getestet).
// Exakt der bisherige onSent-Flow aus TicketDetailsSidebar.tsx.
export async function nachVersand(aktion: TicketAktion, benutzerId: string | null, opts?: { emailVerknuepft?: boolean }): Promise<void> {
  await supabase.from('tickets').update({ status: 'warten_auf_dienstleister' }).eq('id', aktion.ticket_id);
  await supabase.from('ticket_historie').insert({
    ticket_id: aktion.ticket_id,
    benutzer_id: benutzerId,
    aktion: 'beauftragt',
    neuer_wert: `Handwerker beauftragt: ${aktion.empfaenger}`,
  });
  // Mail hängt als Thread-Eintrag am Ticket → kein Volltext-Spiegel-Kommentar mehr nötig.
  if (opts?.emailVerknuepft) return;
  await supabase.from('ticket_kommentare').insert({
    ticket_id: aktion.ticket_id,
    autor_id: benutzerId,
    inhalt: `Auftrag an Handwerker gesendet:\n\n${aktion.entwurf_text}`,
    ist_intern: true,
  });
}

export const handwerkerBeauftragenModul: AktionModul = { typ: 'handwerker_beauftragen', erzeugen, nachVersand };
